import { render, staticRenderFns } from "./jsonDataSlide.vue?vue&type=template&id=63e048b8&"
import script from "./jsonDataSlide.vue?vue&type=script&lang=js&"
export * from "./jsonDataSlide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports